import { chakraSelectDarkMode, defaultChakraSelectStyle } from '@/constants';
import { InfoIcon } from '@chakra-ui/icons';
import {
    Box,
    FormControl,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    Tooltip,
} from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import style from '../../edit/styles';
import { useDefinedAttributes } from '../DefinedAttributesContext';
import useDefinedAttributeValidation from './useDefinedAttributeValidation';

export default function ListAttribute({ attribute, index, requiredScope }) {
    const validation = JSON.parse(attribute.definedAttributeValidationType);
    const { darkMode } = useSelector((state) => state.settings);
    const chakraSelectDark = chakraSelectDarkMode(darkMode);

    const { attributesErrors } = useDefinedAttributes();
    const error = attributesErrors.find((obj) => obj.id === index);

    const [validValues] = useState(() =>
        validation.ValidValues.split(',')
            .map((value) => value.trim())
            .filter((value) => value !== '')
            .map((value, index) => ({ index, value })),
    );

    const { removeAttributeError, handleAttributeChange } =
        useDefinedAttributeValidation();

    return (
        <Box sx={style.fieldContainer}>
            <FormControl isRequired={validation.Required} isInvalid={error}>
                <FormLabel sx={style.label}>
                    {attribute.name}{' '}
                    {attribute.toolTip && (
                        <Tooltip
                            label={attribute.toolTip}
                            hasArrow
                            placement="top-end">
                            <InfoIcon />
                        </Tooltip>
                    )}
                </FormLabel>
                <Select
                    value={validValues?.find(
                        (item) => item.value === attribute.value,
                    )}
                    options={validValues}
                    onChange={(e) => {
                        removeAttributeError(index);
                        handleAttributeChange(e.value, index);
                    }}
                    placeholder="Please select an option"
                    getOptionLabel={(i) => i.value}
                    menuPosition="fixed"
                    maxMenuHeight={200}
                    chakraStyles={{
                        ...defaultChakraSelectStyle,
                        ...chakraSelectDark,
                    }}
                    isDisabled={requiredScope < attribute.updateScope}
                    selectedOptionColor="brand"
                />

                {error ? (
                    <FormErrorMessage>{error.message}</FormErrorMessage>
                ) : attribute?.description ? (
                    <FormHelperText>{attribute?.description}</FormHelperText>
                ) : null}
            </FormControl>
        </Box>
    );
}
